import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';
import { DeadlineMonthTypeEnum } from '@zaoblako/shared/common/enums/deadline.month.type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';

import * as yup from 'yup';

/** Deadline settings response body - DTO signature */
export interface DeadlineFindInterface {
  /** Type of deadline */
  type: DeadlineTypeEnum;
  /**
   * How many days need to add (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.RELATIVE}
   */
  daysAfter: number;
  /**
   * Which day of month need to set (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.ABSOLUTE}
   */
  dayOfMonth: number;
  /**
   * Which month need to use (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.ABSOLUTE}
   */
  monthType: DeadlineMonthTypeEnum;
}

/** Deadline settings response body - DTO schema */
export const DeadlineFindDto = SerdeDtoClass.create<DeadlineFindInterface>(CommonDtoKeysEnum.DEADLINE_FIND_DTO, {
  type: {
    label: 'Тип дедлайна',
    hint: 'Определяет стратегию вычисления даты дедлайна',
    serializer: yup
      .string()
      .oneOf(Object.values(DeadlineTypeEnum)),
  },
  daysAfter: {
    label: 'Дней спустя',
    hint: 'Количество дней, которые нужно добавить к дате. Определен только если тип дедлайна равен `DeadlineTypeEnum.RELATIVE`',
    serializer: yup.number(),
  },
  dayOfMonth: {
    label: 'Дней спустя',
    hint: 'День месяца. Определен только если тип дедлайна равен `DeadlineTypeEnum.ABSOLUTE`.',
    serializer: yup.number(),
  },
  monthType: {
    label: 'Тип месяца',
    hint: 'Определяет, какой месяц надо использовать для дедлайна. Определен только если тип дедлайна равен `DeadlineTypeEnum.ABSOLUTE`.',
    serializer: yup
      .string()
      .oneOf(Object.values(DeadlineMonthTypeEnum)),
  },
});
